const Container = () => import('@/pages/system/attachment/container')

const CreateContainer = () => import('@/pages/system/attachment/container/create')

export default {
  path: 'container',
  meta: {
    label: 'container',
    auth: 'container'
  },
  component: {
    name: 'Container',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemContainerReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Container
    },
    {
      name: 'SystemCreateContainer',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateContainer
    }
  ]
}
